import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState } from 'react';
function Checkbox(_ref) {
  var id = _ref.id,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  var _useState = useState(checked),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsCheck = _useState2[1];
  return /*#__PURE__*/React__default.createElement("label", {
    className: ['sendbird-checkbox', disabled ? 'disabled' : ''].join(' '),
    htmlFor: id
  }, /*#__PURE__*/React__default.createElement("input", {
    disabled: disabled,
    id: id,
    type: "checkbox",
    checked: isChecked,
    onClick: function onClick() {
      if (!disabled) setIsCheck(!isChecked);
    },
    onChange: onChange
  }), /*#__PURE__*/React__default.createElement("span", {
    className: ['sendbird-checkbox--checkmark', disabled ? 'disabled' : ''].join(' ')
  }));
}
export { Checkbox as default };